var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F9F0F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0298 18C22.0298 16.9375 22.9048 16 24.0298 16H40.0298C41.0923 16 42.0298 16.9375 42.0298 18C42.0298 19.125 41.0923 20 40.0298 20H38.1548L38.8423 29.3125C41.1548 30.5625 42.9673 32.625 43.8423 35.1875L43.9048 35.375C44.0923 36 44.0298 36.6875 43.6548 37.1875C43.2798 37.6875 42.6548 38 42.0298 38H22.0298C21.3423 38 20.7798 37.75 20.4048 37.1875C19.9673 36.6875 19.9048 36 20.0923 35.375L20.1548 35.1875C21.0298 32.625 22.8423 30.5625 25.1548 29.3125L25.8423 20H24.0298C22.9048 20 22.0298 19.125 22.0298 18ZM30.0298 40H34.0298V46C34.0298 47.125 33.0923 48 32.0298 48C30.9048 48 30.0298 47.125 30.0298 46V40Z",
    fill: "#B43A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.e45d84c9a6fa7404428f354828906b4b.svg";
export { ForwardRef as ReactComponent };